export default "__VITE_ASSET__e6NVCEhe__"